// Way2Will W Logo Component
// Premium logo with W and upward arrow representing growth and achievement

export function WLogo({ className = "w-8 h-8" }: { className?: string }) {
    return (
        <img
            src="/logo.png"
            alt="Way2Will"
            className={className}
            style={{ objectFit: 'contain' }}
        />
    );
}

export default WLogo;
